import { render, staticRenderFns } from "./events.vue?vue&type=template&id=4c4d327a&scoped=true"
import script from "./events.vue?vue&type=script&lang=js"
export * from "./events.vue?vue&type=script&lang=js"
import style0 from "./events.vue?vue&type=style&index=0&id=4c4d327a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d327a",
  null
  
)

export default component.exports